module.exports = "dist/logo_corporate.png?58ca6acc5b130cc42487bef6798d291e";